import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { isNullOrUndefined } from 'util';
import { DialogCreaUsuario } from './crear-usuario.component';
import { DialogEditaUsuario } from './edita-usuario.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
declare const Rut: any;
@Component({
    selector: 'app-mantenedor-usuarios',
    templateUrl: '../../pages/mantenedor-usuarios/mantenedor-usuarios.component.html',
    styleUrls: ['../../pages/mantenedor-usuarios/mantenedor-usuarios.component.css']
})
export class MantenedorUsuariosComponent implements OnInit {
    rol: string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")

    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }

    usuarios: any
    usuariosFinales: any
    buscador: any = { correo: '', rut: '' }

    constructor(private dialog: MatDialog, private mantenedorService: MantenedorUsuariosService) { }

    ngOnInit(): void { this.loadData() }

    loadData() {
        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        this.mantenedorService.traeUsuarios().then
            (
                (usuarios: any) => {
                    console.log(usuarios)

                    vm.usuarios = usuarios
                    vm.usuariosFinales = usuarios
                    Swal.close();
                    vm.config.totalItems = usuarios.length
                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                vm.openAlertDialog("No hay registros disponibles.", "btn-danger")
            })
    }

    buscar() {
        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        console.log(vm.buscador)
        let rut = "";
        let dv = "";
        let rutEnvio = "0";
        /*
        if (vm.buscador.rut && !Rut(vm.buscador.rut)) {
            Swal.close();
            this.openAlertDialog('El rut no tiene un formato válido.', 'btn-dark')
            return false
        }
        */
        /*
        if (vm.buscador.correo && vm.buscador.correo != "" && !vm.buscador.correo.includes("@")) {
            Swal.close();
            this.openAlertDialog('El correo no tiene un formato válido', 'btn-dark')
            return false
        }
        */
        /*
        if (vm.buscador.rut && vm.buscador.rut != "" && !vm.buscador.rut.includes("-")) {
            Swal.close();
            this.openAlertDialog('El rut no tiene un formato válido', 'btn-dark')
            return false
        }
        */
        
        if (vm.buscador.rut && vm.buscador.rut.includes("-")) {
            dv = vm.buscador.rut.split('-')[1];
            rutEnvio = vm.buscador.rut.split('-')[0];

            if (!dv) {
                Swal.close();
                this.openAlertDialog('El rut no tiene un formato válido!', 'btn-dark')
                return false
            }
        }else{
            rutEnvio = vm.buscador.rut
        }
        


        this.mantenedorService.usuarioBuscador(vm.buscador, rutEnvio).then
            (
                (usuarios: any) => {
                    console.log(usuarios)

                   
                    vm.usuariosFinales = usuarios
                    Swal.close();
                    vm.config.totalItems = usuarios.length
                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                vm.usuariosFinales = []
                vm.openAlertDialog("No hay registros disponibles.", "btn-danger")
            })
    }

    crearUsuario() {

        let vm = this
        let data: any = {}

        const dialogRef = this.dialog.open(DialogCreaUsuario, { data: data, disableClose: true, width: '40%' })
        dialogRef.afterClosed().subscribe(() => {
            if (data.recarga) {
                Swal.fire({
                    allowOutsideClick: false,
                    icon: 'info',
                    text: 'Cargando...'
                });
                Swal.showLoading();
                vm.usuariosFinales = []
                vm.loadData()

            }
        })
    }

    editarUsuario(idUsuario: any) {
        let vm = this
        let data: any = {}
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        data.sexos = [{ id: '1', descripcion: 'Hombre' }, { id: '2', descripcion: 'Mujer' }]

        this.mantenedorService.traeEstadoCivil().then(estados => data.estadoCivil = estados)
        this.mantenedorService.traePrevision().then(previsiones => data.prevision = previsiones)
        this.mantenedorService.traeSistemaSalud().then(sistemas => data.sistemaSalud = sistemas)
        this.mantenedorService.traeRegiones().then
            (regiones => { data.regiones = regiones, data.regionesDirDat = regiones })
        this.mantenedorService.traeRoles().then(roles => data.roles = roles)

        this.mantenedorService.traerUsuario(idUsuario).then
            (
                (usuario: any) => {
                    usuario.direccion = usuario.direccionParticular
                    if (usuario.fechaAfiliado) {
                        data.fechaAfiliado = usuario.fechaAfiliado.split('-').length > 0 ?
                            usuario.fechaAfiliado.split('-')[2] + '-' + usuario.fechaAfiliado.split('-')[1] + '-' + usuario.fechaAfiliado.split('-')[0] : ''
                    }

                    if (usuario.fechaNacimiento) {
                        data.fechaNacimiento = usuario.fechaNacimiento.split('-').length > 0 ?
                            usuario.fechaNacimiento.split('-')[2] + '-' + usuario.fechaNacimiento.split('-')[1] + '-' + usuario.fechaNacimiento.split('-')[0] : ''
                    } else {
                        usuario.fechaNacimiento = []
                    }
                    data.usuario = usuario
                    if (usuario.direccion) {
                        vm.mantenedorService.traeComunas(usuario.direccion.idRegion).then(comunas => data.comunas = comunas)
                    } else {
                        usuario.direccion = []
                    }

                    if (usuario.datosLaborales) {
                        vm.mantenedorService.traeComunas(usuario.datosLaborales.direccion.idRegion).then(comunas => data.comunasDirDat = comunas)
                    } else {
                        usuario.datosLaborales = []
                        usuario.datosLaborales.direccion = []
                    }

                    const dialogRef = this.dialog.open(DialogEditaUsuario, {
                        disableClose: true, width: '40%', data: data
                    })

                    dialogRef.afterClosed().subscribe(() => {
                        if (data.recarga) {
                            vm.usuariosFinales = []
                            vm.loadData()
                        }
                    })
                    Swal.close();
                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                vm.openAlertDialog("Ha ocurrido un error al traer los datos del usuario.", "btn-danger")
            })
    }

    modificarEstadoUsuario(idUsuario: any, estado: any) {

        let vm = this

        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de cambiar el estado del Usuario?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    icon: 'info',
                    text: 'Cargando...'
                });
                Swal.showLoading();
                if (estado == 'AFILIADO') { estado = 'DESAFILIADO' }

                else { estado = 'AFILIADO' }

                vm.mantenedorService.modificarEstado(idUsuario, estado).then
                    (
                        () => {
                            vm.openAlertDialog("Se ha modificado exitosamente el estado del usuario.", "btn-success")

                            dialogRef.close()
                            vm.loadData()
                        }
                    )
                    .catch(error => {
                        console.log(error)

                        vm.openAlertDialog("Ha ocurrido un error al modificar el usuario.", "btn-danger")
                        Swal.close();
                        dialogRef.close()
                    })
            }
        })
    }

    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent,
            {
                data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' } }
            })
    }

    pageChanged(event: any) {
        this.config.currentPage = event

        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
    }

    cambiaCantidadRegistros() {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }
}
